import { Component, Prop, Inject, Watch } from "vue-property-decorator";
import Vue from "vue";
import { STYLE_CLASSES } from "../../constants/StyleConstants";
import { Http } from "@status/codes";
import Snackbar from "../Snackbar/Snackbar";
import { FORM_MESSAGES, VJSF_OPTIONS } from "../../constants/FormConstants";
import { FormTemplateService } from "../../../modules/FormTemplate/services/FormTemplateService";
import { FormSchema } from "../../models/FormSchema";
import { SectionGroup } from "../../../modules/ServiceTemplate/models/SectionGroup";
import ModifVJsfInput from "@/shared/components/ModifVJsfInput/ModifVJsfInput.vue";
import { FORM_TEMPLATES_ACCESS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import ShowIcon from "../ShowIcon/ShowIcon.vue";

@Component({
  name: "Stepper",
  components: {
    ModifVJsfInput,
    ShowIcon
  }
})
export default class Stepper extends Vue {
  @Inject() formTemplateService!: FormTemplateService;

  @Prop() private clusters!: SectionGroup[];
  stepperModel = 0;
  currentStep = 0;
  expasionPanel = [];
  cardClass = STYLE_CLASSES.CARD;

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  model: any = {};
  options = VJSF_OPTIONS;
  vjsfKey = 0;
  schema: FormSchema = new FormSchema();
  stepperForm = false;
  currentTemplate = -1;
  loadingData = false;

  updateCurrentStep(index: number) {
    this.currentTemplate = index;
    this.currentStep = this.stepperModel;
  }

  async getFormTemplate(idFormTemplate: string, index: number) {
    if (
      this.currentTemplate !== index ||
      this.currentStep !== this.stepperModel
    ) {
      this.loadingData = true;
      try {
        this.schema = new FormSchema();
        const response = await this.formTemplateService.getFormTemplateSchemaById(
          idFormTemplate
        );

        if (response.code === Http.Found && response.data != null) {
          this.schema = response.data.schema;
          this.vjsfKey++;
          this.currentTemplate = index;
          this.currentStep = this.stepperModel;
        } else {
          Snackbar.popInfo(response.message);
        }
      } catch (error) {
        const errorMessage =
          (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
            ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${FORM_TEMPLATES_ACCESS.GET}`
            : FORM_MESSAGES.REQUEST_FAILED;

        Snackbar.popError(errorMessage);
      }
      this.loadingData = false;
    }
  }

  @Watch("stepperModel")
  stepperModelChange() {
    this.expasionPanel = [];
  }
}
